export const URL_QUERY_DISABLE_LAYOUT = 'is-page'
export const HISTORY_STATE_DROP_BROWSING_STACKS = '@internal/drop-pages'
export const URL_QUERY_DISABLE_APP_LAYOUT = 'single'
export const URL_QUERY_SKIP_LOGIN_TOKEN = 't'
